<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12">
          <h2 class="h2">ネットワークファイアウォールの設定について</h2>
          <p>以下の表を参考に、ファイアウォールを設定を調整下さい。</p>
          <mdb-tbl bordered class="my-4">
            <mdb-tbl-head>
              <tr>
                <th>プロトコル</th>
                <th>ポート</th>
                <th>通信方向</th>
                <th>宛先</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr>
                <th>TCP</th>
                <td>443</td>
                <td>アウトバウンド</td>
                <td>*.waaarp.jp</td>
              </tr>
              <tr>
                <th>UDP or TCP</th>
                <td>40000 - 49999</td>
                <td>インバウンド/アウトバウンド</td>
                <td>3.115.223.193/32</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
          <div class="text-pre-wrap">{{ 'WaaarpではUDPによる通信を推奨しております。\nUDPのポート開放が困難な場合には、TCPのインバウンド/アウトバウンドを設定して下さい。' }}</div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
export default {
  name: 'Help'
}
</script>

<style scoped lang="scss">
</style>
